import React from "react";
import Globals from "../../api";
import "./footer.scss";
import { Nav } from "react-bootstrap";

import android_app from "../../assets/img/android_app.png";
import wd_logo_white from "../../assets/img/svg/wd_logo_w.svg";

export default class Footer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      footerData: [],
      footerLinkData: [],
      bottomMenuData: [], 
      bfooterLinkData: [],
      // ✅ NEW
    };
  }

  componentDidMount() {
    const FooterConurl = Globals.Desktop_footer_based_api;

    fetch(FooterConurl)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          footerData: data.NavigationMenu.Items,
        });
      });

    this.getHomeDetails();
    this.getBottomMenu(); // ✅ NEW CALL
  }

 getHomeDetails() {

  const FooterLinks = Globals.language_based_api;

  fetch(FooterLinks)
    .then((res) => res.json())
    .then((data) => {

      const footerMenu =
        (data.Contents || []).filter(
          (x) => x.Type === "FooterMenu"
        );

      this.setState({
        footerLinkData: data.Contents || [],
        bfooterLinkData: footerMenu
      });

    });
}
  // ✅ FETCH BOTTOM MENU
  getBottomMenu() {
    fetch(
      "https://nonprod-media.webdunia.com/public_html/_media/bottomMenu/bottom_menu_mr.json"
    )
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          bottomMenuData: data.contents || [],
        });
      })
      .catch((err) => console.error("Menu fetch error:", err));
  }

  render() {
    const currentPath = window.location.pathname;
  

    let footerItems = this.state.footerLinkData.map((item, i) => (
      <li key={i}>
        <a href={item.DefaultUrl}>{item.Text}</a>
      </li>
    ));

    const NavMenu = this.state.footerData.map((item, i) => (
      <div className="footer_widget" key={i}>
        <h3>
          <Nav.Link href={item.DefaultUrl}>{item.Text}</Nav.Link>
        </h3>
        <ul className="footer_menus">
          {item.Items.map((subItem, j) => (
            <li key={j}>
              <Nav.Link href={subItem.DefaultUrl}>
                {subItem.Text}
              </Nav.Link>
            </li>
          ))}
        </ul>
      </div>
    ));

    return (
      <>
        {/* ================= BOTTOM MENU ================= */}
        <div className="bottom_menu_sect">
          <div className="wd_b_nav">
            {this.state.bottomMenuData.map((menu, index) => {
              const isActive = menu.url === currentPath;

              return (
                <div className="bottom_m_link" key={index}>
                  <a href={menu.url}>
                    <span
                      className="bm_icon"
                      style={{
                        backgroundImage: `url(${isActive
                            ? menu.IconActiveImage
                            : menu.IconImage
                          })`,
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundImage = `url(${menu.IconActiveImage})`)
                      }
                      onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundImage = `url(${isActive
                          ? menu.IconActiveImage
                          : menu.IconImage
                        })`)
                      }
                    ></span>

                    <span className="bm_lable">{menu.title}</span>
                  </a>
                </div>
              );
            })}
          </div>
        </div>

        {/* ================= FOOTER ================= */}
        <div className="footer_seciton">
          <div className="footer_top_sect">
            <div className="container">
              <div className="apps_link">
                <a href="https://play.google.com/store/apps/details?id=com.webdunia.app&hl=en" aria-label="Android app">
                  <img src={android_app} alt="Android" width="180" />
                </a>
              </div>
            </div>
          </div>

          <div className="footer_sect">
            <div className="container">
              <div className="row">
                <div className="col-lg-2">
                  <div className="footer_about">
                    <img src={wd_logo_white} alt="Webdunia" width="196" />

                    <div className="f_social_block">
                      <span>FOLLOW US ON</span>
                      <ul className="f_follow_us">
                        <li>  <a title="facebook" alt="facebook" href="https://www.facebook.com/pages/Webdunia-Marathi/200500146630288" target="_blank" className="f_fb_icon"></a> </li>
                        <li> <a title="twitter" alt="twitter" href="https://x.com/webduniaMarathi/" target="_blank" className="f_tw_icon"></a> </li>
                        <li><a title="instagram" alt="instagram" href="https://www.instagram.com/webdunia.marathi/" className="f_yt_icon"></a></li>
                        <li><a title="youtube" alt="youtube" href="https://www.youtube.com/channel/UCoTF_xCCgkunYboLK0gmz8g" target="_blank" className="f_inst_icon"></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-lg-10">
                  <div className="foot_menu_list">{NavMenu}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer_bottom_sect">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <ul className="footer_menu_link">{footerItems}</ul>
                </div>
                <div className="col-lg-4">
                  <p className="copyright_text">
                    Copyright {new Date().getFullYear()}, Webdunia.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}